export default {
  Andpenalties: 'Dommages-intérêts et pénalités',
  DeliveryFailed: 'La livraison a échoué, les remboursements sont à la charge de la partie A',
  abandonedRequests: 'Commande abandonnée',
  abandonedorder: 'Commande abandonnée',
  accesshelpcenter: 'Accédez à notre centre d\'aide',
  accessoriesLessDelivery: 'Manque d\'accessoires, moins la livraison, les remboursements sont à la charge de la partie A',
  accesstoken: 'Jeton d\'accès',
  accessurlexample: 'Exemple : votre-boutique.com',
  accessurlprefix: 'L\'URL ne peut pas contenir les valeurs suivantes : www., https://, http://, /',
  actions: 'Actes',
  activate: 'activer',
  activateStore: 'Si vous comptez utiliser notre boutique en ligne, activez-la pour libérer tous les enregistrements DNS.',
  active: 'ACTIVE',
  active2: 'Active',
  actuallyPrice: 'En fait le prix',
  addDomainTips1: 'Liez un domaine qui vous appartient déjà.',
  addDomainTips2: 'Vous pouvez également lier un sous-domaine. Assurez-vous de commencer votre formulaire par « pay » ou « pago ». Ex.:',
  addDomainTips3: 'Ne pas utiliser',
  addDomainTips4: 'Gardez l\'oeil ouvert ! pour que votre domaine fonctionne,',
  addDomainTips5: 'vous devez l\'acheter et le configurer avec un service d\'hébergement',
  addDomainTips6: 'ou un autre.',
  addDomainTips7: 'Si vous avez des questions, veuillez consulter notre',
  addPopup: 'Ajouter un coupon',
  addastore: 'Ajouter un magasin',
  addstore: 'Ajouter un magasin',
  afterEachSuccessful: 'Après chaque transaction réussie de la partie B, la partie A retirera 5 % du montant de la transaction réussie de la partie B et conservera la marge renouvelable sur le compte de la partie A tout en la transférant à la partie B. La marge renouvelable sur le compte de la partie A pour chaque transaction sera conservée pendant 45 jours et le montant sera remis à la partie B après 45 jours.',
  afterSales: 'C\'est la boîte aux lettres après-vente. Les clients envoient des questions après-vente à cette boîte aux lettres et l\'équipe après-vente y répondra.',
  afterVerification: 'Si le motif du remboursement correspond aux cinq situations suivantes après vérification, le remboursement sera à la charge de la partie B.',
  agreetoNY: '"En créant un compte, vous acceptez celui de USAdrop"',
  alreadyhaveanaccount: 'Vous avez déjà un compte ?',
  and: 'et',
  apikey: 'Clé API/ID client',
  apisecretkey: 'Clé secrète API / Secret',
  ativo: 'ACTIVE',
  backgroundColor: 'Couleur d\'arrière-plan',
  basicinformation: 'Informations de base',
  blacklisted: 'Si le client est mis sur liste noire, le remboursement sera annulé et supporté par la partie B.',
  blacklistedCustomer: 'Client sur liste noire, annuler le remboursement',
  borneByParty: 'En raison du non-paiement de la partie B à temps, le client demande l\'annulation de la commande et le remboursement sera à la charge de la partie B.',
  borneParty: 'Si le produit n\'est pas satisfaisant (ne l\'aime pas), le remboursement sera à la charge de la partie A.',
  buttonText: 'Texte du bouton',
  cancel: 'Annuler',
  cancellationAnd: 'Si la commande n\'est pas expédiée et que le client demande l\'annulation et le remboursement, le remboursement sera à la charge de la partie B.',
  cardPaymentsAnswer: 'Une fois que le client aura payé sur notre compte, celui-ci sera transféré sur votre portefeuille le lendemain.',
  cardPaymentsTitile: 'Combien de temps faut-il pour que le montant soit transféré sur mon compte une fois que les clients ont passé commande ?',
  carddesc: 'CARTES, BOLETO, DÉPÔT BANCAIRE ET PIX',
  changeAddress: 'Pour les demandes de changement d\'adresse après l\'expédition des marchandises, le remboursement sera à la charge de la partie B.',
  classic: 'Classique',
  collaboratorRequestCode: 'Stocker les autorisations et les codes des collaborateurs (Notre e-mail est _email_, veuillez traiter l\'autorisation)',
  collapsemenu: 'Réduire le menu',
  confirm: 'Confirmer',
  confirmedAndThe: 'Si la commande doit être confirmée et que le client ne répond pas pendant plus de 2 jours, le remboursement sera à la charge de la partie B.',
  confirmpassword: 'Confirmez votre mot de passe',
  contentTerms: 'Conditions de contenu',
  convertedOrderPaid: 'Commande convertie (payée)',
  convertedOrderUnpaid: 'Commande convertie (non payée)',
  copy: 'copie',
  correspondingPenalties: 'La partie B doit se conformer aux lois et réglementations ainsi qu\'à la partie A et aux exigences de gestion des risques de l\'organisme de carte pour les transactions illégales. Si la Partie B enfreint l\'une de ces réglementations, la Partie B sera soumise aux pénalités et amendes correspondantes.',
  countdownImage: 'Image du compte à rebours',
  countdownTimer: 'Compte à rebours',
  countdownBg: 'Couleur d\'arrière-plan du compte à rebours',
  countdownTextColor: 'Couleur du texte du compte à rebours',
  country: 'Pays',
  coupon: 'Coupon',
  couponCode: 'Code de réduction (facultatif)',
  creatanaccount: 'Créer un compte',
  createTime: 'Créer du temps',
  createaccounttitle: 'Créez votre compte gratuit sur notre forfait Basic, sans frais mensuels.',
  createfreeaccount: 'Créer un compte gratuit',
  createpassword: 'Créer un mot de passe',
  currencyConversionAnswer: 'Conversion basée sur le taux de change officiel fourni par le fournisseur de paiement',
  currencyConversionTitle: 'Problèmes de conversion de devises ?',
  currentStoreName: 'Magasin actuel :',
  customerBuysMore: 'Si le client achète plus et souhaite annuler et rembourser, le remboursement sera à la charge de la partie B.',
  date: 'Date',
  days: 'jours',
  defaultDomainTips: '"Il s\'agit du domaine gratuit fourni par USAdrop. Cela fonctionnera toujours. Mais nous vous indiquons de créer le vôtre."',
  delete: 'Supprimer',
  deleteSelected: 'SUPPRIMER LA SÉLECTION',
  deleteSuccess: 'Suppression réussie !',
  deletedSuccessfully: 'Supprimé avec succès',
  deliveryTime: 'Le client reçoit la marchandise, le délai de livraison est trop long, dépassant le délai du magasin, les remboursements sont à la charge de la partie A',
  disable: 'Désactiver',
  disabledSuccessfully: 'Désactivé avec succès',
  discount: 'Rabais',
  discountAmount: 'Montant de la remise',
  discountPercent: 'Pourcentage de remise',
  discountRate: 'Paramètres de remise',
  dnsNormal: 'La configuration des enregistrements DNS est normale',
  dnsNotConfigured: 'Enregistrement DNS non configuré ou non propagé.',
  dnsRecordsTitle: 'Enregistrements DNS pour votre boutique en ligne',
  domain: 'Domaine',
  domainbtntext: 'Installation',
  domaintitle: 'Configurez ici le même domaine que votre boutique Shopify.',
  eachSuccessfulTransaction: 'Après chaque transaction réussie de la partie B, la partie A retirera 10 % du montant de la transaction réussie de la partie B et conservera la marge renouvelable sur le compte de la partie A tout en la transférant à la partie B. La marge renouvelable sur le compte de la partie A pour chaque transaction sera conservée pendant 45 jours et le montant sera remis à la partie B après 90 jours.',
  edit: 'Modifier',
  editstore: 'Modifier le magasin',
  email: 'E-mail',
  emailContent: 'Contenu du courrier électronique',
  emailReminders: 'Cadre promotionnel',
  emailRemindersDesc: 'Configurer des rappels par e-mail et des remises sur les commandes',
  emailTemplateConfig: 'Configuration du modèle d\'e-mail',
  emailTemplateConfigDesc: 'Contenu de courrier électronique personnalisé',
  emailTitle: 'Objet de l\'e-mail',
  embedPaymentMethods: 'Utilisez les e-mails pour inciter les clients à effectuer le paiement à différents moments afin d\'augmenter les taux de conversion des commandes.',
  emptyCouponDesc: 'Après avoir configuré le coupon, une fenêtre contextuelle permettant de réclamer le coupon apparaîtra après avoir effectué le paiement, encourageant l\'utilisateur à utiliser le coupon pour une meilleure offre.',
  emptyCouponTitle: 'Configurez votre coupon',
  enable: 'Activer',
  enableCouponTips: 'Un seul coupon peut être actif à la fois. Veuillez désactiver les autres coupons avant de continuer !',
  enabledSuccessfully: 'Activé avec succès',
  end: 'Fin',
  endDate: 'Date de fin',
  enter: 'Entrer',
  entercorrectemail: 'Veuillez saisir le format d\'e-mail correct',
  enteremailandpassword: 'Entrez votre email et votre mot de passe',
  example: 'Exemple',
  faqs: 'FAQ',
  firstPaymentChannel: 'Mode de paiement pour la première commande',
  firsttimeaNY: 'Première fois sur USAdrop ?',
  followInstructions: 'Suivez les instructions',
  followingPenalties: 'En plus des amendes mentionnées ci-dessus, ceux qui enfreignent gravement la réglementation s\'exposeront aux sanctions suivantes :',
  forBrazil: 'Pour le Brésil :',
  forMexico: 'Pour le Mexique/Chili/Colombie/Pérou :',
  forPaymentFailure: 'En cas de défaut de paiement, le remboursement sera à la charge de la Partie B',
  forShopify: 'Lorsque vous vous inscrivez à Shopify, votre boutique en ligne reçoit une URL « myshopify.com ».',
  forgetpassword: 'J\'ai oublié mon mot de passe',
  fullname: 'Nom et prénom',
  goodsNum: 'articles',
  gtm: 'Code (GTM-XXXXXXX)',
  gtmRequired: 'L\'ID du conteneur est requis',
  gtmDomain: 'URL du conteneur du serveur',
  gtmDomainRequired: 'L\'URL du conteneur du serveur est requise',
  googleid: 'ID de mesure',
  googlekey: 'Secrets de l\'API du protocole de mesure',
  googleidRequired: 'L\'ID de mesure est requis',
  googlekeyRequired: 'Les secrets de l\'API du protocole de mesure sont requis',
  hasBeenSigned: 'La logistique montre qu\'il a été signé, mais le client ne l\'a pas reçu, les remboursements sont à la charge de la partie A',
  hasquestions: 'Vous avez des questions ?',
  headerImage: 'Image d\'en-tête',
  helpCenter: 'Centre d\'aide',
  helpaddress: 'bento.me/enchentesrs',
  hi: 'Salut',
  holding: '1、Tenir',
  home: 'Maison',
  howtocontribute: 'Découvrez comment contribuer sur',
  howtoset: 'Comment définir',
  identifyyourself: 'Identifiez-vous',
  imitationBrand: 'Marque d\'imitation/imitation',
  inActive: 'INACTIVE',
  inativo: 'INATIVO',
  info: 'Information',
  installtitle: 'Installez USAdrop Transparent Checkout sur votre boutique Shopify.',
  invitationNumber: 'Code d\'invitation',
  invitationNumberError: 'Veuillez saisir votre numéro d\'invitation pour finaliser votre inscription',
  isConfirmDelete: 'Êtes-vous sûr de vouloir le supprimer ?',
  kEmail: 'E-mail',
  kName: 'Nom',
  learnMore: 'apprendre encore plus.',
  lengthLimit: 'La longueur doit être de 3 à 8',
  letteringPattern: 'Qualité du produit (taille, différence de couleur, dommages, taches, extrémités de fil, odeur, rides, décoloration, rétrécissement, lettrage, motif, logo, accessoires), les remboursements sont à la charge de la partie A.',
  like: 'comme',
  linkNewDomain: 'Lier un nouveau domaine',
  liquidatedDamages: 'Dommages-intérêts et pénalités.',
  logaccount: 'Vous êtes connecté à :',
  loginsuccess: 'connexion réussie !',
  logout: 'Déconnexion',
  logoutSYS: 'Faut-il se déconnecter du système ?',
  lougoutsuccess: 'Déconnexion réussie !',
  markAsActive: 'Marquer comme actif',
  markAsInactive: 'Marquer comme inactif',
  min: 'min',
  mydomain: 'Mon domaine',
  mydomains: 'Mes domaines',
  mydomainsdesc: 'Gérez vos domaines ici. Liez vos domaines et configurez-les pour qu\'ils soient l\'adresse virtuelle de votre boutique et de votre caisse.',
  name: 'NOM:',
  needhelp: 'Le Rio Grande do Sul a besoin de votre aide.',
  newaffiliations: 'Nouveau pays',
  newpixel: 'Nouveau pixel',
  nextPage: 'Page suivante',
  no: 'Non',
  noDomain: 'Aucun domaine',
  noStatus: 'Aucun statut',
  noUseDefaultDomain: 'N\'utilisez pas le domaine payant par défaut d\'USAdrop !',
  noUseOrgin: 'N\'utilisez pas http:// https:// et www',
  nocountriesavailable: 'Aucun pays disponible',
  nodatareadtitle: 'Lire notre article complet',
  nodatastartsell: 'Lorsque vous commencerez à vendre, vos commandes apparaîtront ici.',
  nodatatip1: 'Personnalisez votre boutique au look de votre entreprise !',
  nodatatip2: 'Proposez différents modes de paiement.',
  nodatatip3: 'Ajoutez de bonnes photos à vos produits.',
  nodatatip4: 'Rendez vos descriptions de produits attrayantes et utilisez des techniques de référencement.',
  nodatatip5: 'Investissez dans le trafic payant : publicités sur les réseaux sociaux et Google shopping.',
  nodatatip6: 'Vérifiez si le prix de vos produits est attractif.',
  nodatatip7: 'Disposer d\'un canal de service client pour répondre aux questions',
  nodatatips: '7 conseils rapides pour réaliser votre première vente :',
  nodatatitle: 'Il n\'y a pas encore de commandes à afficher',
  nodeDescription: 'Description de la situation déclenchante',
  nodeName: 'Situation déclenchante',
  operation: 'Statut',
  order: 'Commande',
  orderCancel: 'Annulé',
  orderClosed: 'Fermée',
  orderConversion: 'Statut des commandes',
  orderDeliver: 'Livrer',
  orderEnd: 'Complété',
  orderPaid: 'Payé',
  orderReceived: 'Livré',
  orderToAnalyze: 'Afin d\'analyser les sources des différentes commandes et d\'ajuster les publicités dans le temps, nos données sont plus précises que celles de Facebook.',
  orderWaitPay: 'En attente',
  ordernum: 'Numéro de commande',
  ordertime: 'Heure de commande',
  originurl: 'Adresse du site Web',
  originurlexample: 'Exemple : votre-boutique.myshopify.com',
  originurlprefix: 'L\'URL ne peut pas contenir les valeurs suivantes : www., https://, http://, /, .br',
  package: 'Si le client refuse d\'accepter le colis et demande un remboursement, le remboursement sera à la charge de la partie B.',
  partyAProvides: 'La partie A fournit un service de garantie de remboursement pour les commandes coopératives moyennant des frais de 1,5 %. S\'il s\'avère que le motif du remboursement est que le client n\'est pas satisfait du produit après l\'avoir reçu, les frais de remboursement seront supportés par la partie A et la partie B n\'aura pas besoin de supporter les pertes associées. Pour des scénarios d\'utilisation spécifiques, veuillez vous référer à l\'annexe du contrat système.',
  partyAProvidesconsumers: 'Pour garantir la stabilité et la conformité des paiements, la partie A sera le seul fournisseur de services après-vente pour la partie B. La partie B autorisera pleinement la partie A à gérer toutes les questions après-vente et à fournir l\'accès au(x) compte(s) de messagerie concerné(s). Tout service après-vente par la partie B est exceptionnel et nécessite le consentement préalable de la partie A. Dans de tels cas, la partie B accordera à la partie A un accès complet au(x) compte(s) de messagerie après-vente concerné(s) pour un suivi en temps réel. La violation de cette clause autorise la partie A à suspendre ou à résilier immédiatement l\'accès de B aux services de paiement, sans responsabilité.',
  partyProvides: 'La partie A fournit à la partie B des services de paiement et de règlement sur Internet transfrontaliers, notamment :',
  password: 'Mot de passe',
  payBy: 'PAYER PAR',
  payment: 'Paiement',
  paymentDateAnswer: 'Vous pouvez demander le retrait après avoir payé les frais d’exécution de la commande. Le retrait sera généralement traité dans un délai de 1 à 2 jours ouvrables. L\'heure d\'arrivée finale dépend de votre banque.',
  paymentDateTitle: 'Combien de temps faut-il pour que le retrait soit reçu après que je l\'ai initié ?',
  paymentDomain: 'Résolution du domaine CNAME',
  paymentRatesTitle: 'Paiement et tarifs pour chaque pays',
  paymentServicesToParty: 'La partie A fournit des services de paiement à la partie B, et la partie B doit informer la partie A des informations de connexion du magasin. La partie A fournit également à la partie B des services pertinents de requête d\'informations sur les transactions et de règlements, et la partie B doit coopérer avec la partie A pour maintenir conjointement la stabilité du compte du produit de paiement.',
  paymentSetting: 'Paramètres de paiement',
  paymentTime: 'Délai de paiement',
  paymentaffiliations: 'Paramètres de paiement',
  paymentaffiliationsdesc: 'Les paramètres pour effectuer des transactions dans votre boutique, ainsi que les paramètres de langue et de pays pour l\'interface affichée aux clients',
  paymentbtntext: 'Pour mettre en place',
  paymentdoamin: 'Résolution du domaine CNAME',
  paymentlanguage: 'Langue de la page de paiement',
  paymentoptions: 'Options de paiement',
  paymentoptionsdesc: 'Les options de paiement acceptées dans votre boutique.',
  paymenttitle: 'Configurez les modes de paiement acceptés dans votre boutique.',
  personalInformationVerification: 'Vérification des informations personnelles',
  personalInformationVerificationSubTitle: 'La vérification des informations implique votre numéro de téléphone mobile.',
  phone: 'Numéro de téléphone',
  pixel: 'Pixels',
  pixelIDisRequired: 'L\'identifiant du pixel est requis',
  pixelTokenisRequired: 'Le jeton Pixel est requis',
  pixelexample: 'Exemple : un client voit votre annonce, visite votre site Web et effectue un achat. Pixel suit cela, vous aidant à savoir quelles annonces génèrent le plus de ventes.',
  pixelhelp: 'Analysez les performances de vos campagnes marketing et voyez comment vos clients interagissent avec vos publicités et votre boutique.',
  pixelid: 'Pixel LD',
  pixelname: 'Nom du pixel',
  pixeltoken: 'Jeton de pixels',
  platforms: 'PLATEFORMES',
  pleaseFillTheRequiredFields: 'Veuillez remplir les champs obligatoires',
  pleaseInput: 'Veuillez saisir',
  pleaseInputDomain: 'Veuillez saisir le domaine',
  pleaseSelect: 'Veuillez sélectionner',
  pleaseSelectDate: 'Veuillez sélectionner une date',
  pleconfirmPWD: 'Veuillez confirmer le mot de passe',
  pleinputPWD: 'Veuillez saisir le mot de passe',
  popup: 'Surgir',
  popupBackground: 'Arrière-plan contextuel',
  popupConfig: 'Configuration des fenêtres contextuelles',
  popupConfigDesc: 'Effet d\'affichage contextuel et règles contextuelles',
  popupCycle: 'Cycle pop-up',
  popupCycleItem: 'Utilisateur novice, pop-up tous les {input} jours',
  preview: 'Aperçu',
  previousPage: 'Page précédente',
  priceTerms: 'Conditions de prix',
  privacypolicy: 'politique de confidentialité',
  processingTime: 'La partie A exécutera toutes les commandes du magasin de la partie B et mettra à jour le délai de traitement, le délai d\'expédition, les descriptions de produits dans le magasin de la partie B, etc. conformément aux exigences de la partie A. S\'il y a des éléments d\'ajustement, tels que des produits en rupture de stock et des produits similaires, la partie B doit terminer l\'ajustement/suppression dans les 12 heures.',
  product: 'Produit',
  productSpecifications: 'Mauvais produit, couleur, taille, autre SPU, spécifications, les remboursements sont à la charge de la partie A.',
  productsImitation: 'Produits d\'imitation_marques d\'imitation, le remboursement sera à la charge de la partie B',
  propertyRights: 'Le téléchargement et la vente de produits portant atteinte aux droits de propriété intellectuelle sont interdits.',
  protocolBtnPrefix: 'J\'accepte le',
  protocolBtnTitle: 'Conditions générales de paiement et politique de confidentialité',
  protocolDialog: 'Contrat d\'utilisation',
  questionsSupport: 'Si vous avez des questions, veuillez utiliser notre matériel d\'assistance répertorié ci-dessous :',
  recommendSize: 'Taille recommandée : {input}',
  recoverpassowrd: 'Récupérer le mot de passe',
  recovertitle: 'Entrez votre adresse e-mail ci-dessous',
  rectifiedAccording: 'Pour les remboursements de commandes non rectifiées conformément aux exigences de la partie A, le remboursement sera à la charge de la partie B.',
  redirectLink: 'Lien de redirection',
  refundGuaranteeFees: 'Frais de garantie de remboursement',
  refundGuaranteeTerms: 'Conditions de garantie de remboursement',
  refundShallBe: 'Si le produit n\'est pas examiné et que le produit est en rupture de stock, le remboursement sera à la charge de la partie B.',
  refundsAreBorne: 'Les informations logistiques montrent qu\'il n\'a pas été livré/mis à jour depuis longtemps, les remboursements sont à la charge de la partie A',
  refundsAreGiven: 'Le produit a été examiné, le produit est en rupture de stock et les remboursements sont accordés au client, les remboursements sont à la charge de la partie A.',
  register: 'Registre',
  registersuccess: 'Enregistrez le succès !',
  registertips: 'Nous utiliserons vos données pour créer votre compte d\'accès et envoyer des informations qui vous aideront à activer votre boutique.',
  requestNumber: 'NUMÉRO DE COMMANDE',
  requests: 'Commande',
  requestsCancellation: 'La commande n\'a pas été expédiée et le client demande l\'annulation',
  save: 'Sauvegarder',
  saveFields: 'Après avoir rempli les champs, enregistrez ce que vous avez rempli.',
  saveSuccessfully: 'Enregistrer avec succès',
  search: 'Recherche',
  secondarydomains: 'Domaines secondaires',
  selectCountry: 'Sélectionnez un pays',
  selectTimeZone: 'Sélectionnez le fuseau horaire',
  service: 'Service',
  serviceemail: 'E-mail du service client',
  setUpDomain: 'Configurez votre domaine auprès de votre fournisseur en suivant les étapes ci-dessous.',
  settings: 'Paramètres',
  settlementPeriod: 'Prolonger le délai de règlement ou suspendre le règlement ; La partie A a le droit de résilier le contrat et de ne pas le restituer à la partie B. Le montant non réglé et le dépôt seront réglés à un autre moment convenu après six mois.',
  shipped: 'Le délai de commande est inférieur ou égal à 3 jours, la commande a été expédiée et le client demande l\'annulation et le remboursement, et le remboursement sera à la charge de la partie B.',
  shopify: 'Shopify',
  shopifybtntext: 'Installer',
  shopifytitle: 'Installez Transparent Checkout sur votre boutique Shopify.',
  skipshoppingcart: 'Passer le panier',
  specificRates: '3、Tarifs spécifiques',
  specificUsageScenarios: 'Les remboursements générés par d\'autres méthodes seront à la charge de la partie A. Pour des scénarios d\'utilisation spécifiques, cliquez ici pour',
  sslCertificate: 'CERTIFICAT SSL',
  start: 'Commencer',
  startDate: 'Date de début',
  startUsing: 'Active',
  startconfig: 'Commencez la configuration ici',
  status: 'Statut',
  step1Content: '" Accédez au site Web de votre fournisseur de domaine. Recherchez la section de configuration des enregistrements DNS. "',
  step1Title: '"ÉTAPE 1 : ACCÉDEZ À VOTRE PANNEAU DE FOURNISSEURS"',
  step2Content: 'Chez votre fournisseur, dans la section configuration des enregistrements DNS, ajoutez les informations ci-dessous. Remplissez chaque champ avec les informations respectives répertoriées ci-dessous :',
  step2Title: '"ÉTAPE 2 : ACCÉDEZ À VOTRE PANNEAU DE FOURNISSEURS"',
  step3Content: 'Après avoir correctement complété les entrées ci-dessus auprès de votre fournisseur de domaine, vous devez attendre un moment pour que les informations se propagent. Ce processus prend généralement jusqu\'à 4 heures.',
  step3Title: 'ÉTAPE 3 : ATTENDRE LA PROPAGATION',
  storeAccessingUrl: 'Adresse de la boutique en ligne',
  storeBinding: 'Connecter la boutique',
  storeBindingSettings: 'Paramètres du magasin',
  storeLogo: 'Logo du magasin',
  storeLogoLimitTips: 'Taille recommandée : 230*50, dans les 200 Ko',
  storename: 'Nom du magasin',
  termsofuse: 'conditions d\'utilisation',
  theCheckoutPage: 'Montant/pourcentage de remise : sur la page de paiement, définissez un montant/pourcentage de remise fixe pour inciter les clients à choisir ce mode de paiement.',
  theProductsSold: 'Les produits vendus sur le site Internet comprennent des produits non autorisés par la marque ou utilisant des marques non autorisées par la marque, ainsi que d\'autres produits de la marque ; violation de la propriété intellectuelle hors marque, y compris, mais sans s\'y limiter : les films, vidéos, chansons, jeux, œuvres d\'animation et leurs produits périphériques, y compris, mais sans s\'y limiter, les figurines, accessoires et équipements de personnages.',
  theRefundShall: 'Si le client reçoit la marchandise et que le délai de livraison est trop long et ne dépasse pas le délai de magasin, le remboursement sera à la charge de la partie B.',
  timezone: 'Fuseau horaire',
  tips: 'Conseils',
  toEmbedPaymentMethods: 'Pour intégrer les moyens de paiement.',
  toenter: 'Pour entrer',
  tosave: 'Pour sauvegarder',
  total: 'Totale',
  trackingNumber: 'Numéro de suivi',
  transactionSettlement: 'La partie B accepte que la partie A déduise les frais ci-dessus du montant du règlement de la transaction de la partie B.',
  transferPlatform: 'Plateforme de transfert de commandes',
  tutorial: 'Tutoriel',
  type: 'TAPER:',
  typeofintegration: 'Type d\'intégration',
  typepassword: 'Tapez votre mot de passe',
  unauthorized: 'Pour les transactions non autorisées, le remboursement sera à la charge de la partie B',
  unauthorizedTransaction: 'Transaction non autorisée',
  unconvertedOrder: 'Commande non convertie',
  update: 'Pour mettre à jour',
  urlDisplayed: 'L\'URL affichée dans le navigateur Web lorsque les clients parcourent votre boutique en ligne est un nom de domaine personnalisé.',
  usedNormally: 'Ne peut pas être utilisé normalement, les remboursements sont à la charge de la partie A',
  value: 'VALEUR:',
  wantsToCancel: 'Le client achète plus et souhaite annuler et rembourser',
  whatisapixel: 'Qu\'est-ce qu\'un Pixel ?',
  whatsAppTemplate: 'Modèle WhatsApp',
  whichTimeZoneSetTitle: 'Quel fuseau horaire faut-il définir ?',
  withdrawalFeeAnswer: 'Cela dépend de vos frais bancaires. Différentes banques ont des frais différents.',
  withdrawalFeeTitle: 'Quels sont les frais de retrait ?',
  withdrawalMethodAnswer: 'Après avoir payé les frais d\'exécution, vous pouvez retirer le solde du portefeuille. Les virements bancaires et les retraits Paypal sont pris en charge.',
  withdrawalMethodTitle: 'Comment retirer de l’argent et quelles sont les méthodes de retrait ?',
  yes: 'Oui',
  mismatched: 'Fête B',
  mustNotSell: 'ne doit pas vendre d\'articles de marque,',
  brandIconsMust: 'et les icônes de marque ne doivent pas apparaître dans les descriptions de produits. Une fois que la partie A découvre qu\'il y a un produit de marque illégal ou incompatible dans le magasin de la partie B, la partie A suspendra tous les paiements au magasin de la partie B dans les 6 heures et arrêtera tout paiement. La partie A aura le droit de procéder au remboursement de toute commande non conforme ou en infraction, et tous les coûts et dépenses en découlant seront supportés uniquement par la partie B. Le montant spécifique de l\'amende est indiqué dans',
  theRefund: 'Le service de garantie de remboursement comprend les éléments suivants :',
  refundGuarantee: 'Conditions de garantie de remboursement.',
  priceList: 'Liste de prix',
  Holding: 'Holding',
  appendixTwo: 'Annexe 2.',
  paymentPriceList: 'Liste de prix de paiement',
  howDoes: 'Qu\'est-ce que le dropshipping et comment ça marche',
  whatIsPayment: 'Qu\'est-ce que le paiement USAdrop',
  differenceDropshipping: 'La différence entre le paiement à la livraison et le Dropshipping',
  howsySterm: 'Comment utiliser le système USAdrop',
  howShopifyAPI: 'Comment configurer l\'API Shopify',
  howDomain: 'Comment configurer un domaine',
  howPixel: 'Comment configurer Pixel',
  howCoupon: 'Comment configurer le coupon',
  pleaseShopifyStore: 'Veuillez vous assurer que le domaine est connecté à votre boutique Shopify !',
  feeTerms: 'Conditions tarifaires',
  noRefundGuarantee: 'Aucun frais de garantie de remboursement au Brésil',
  deleteShopify: 'Comment supprimer ou ajouter le bouton dynamique « Acheter maintenant » et le bouton « Ajouter au panier » dans Shopify',
  stepOne: 'Étape 1, accédez à « Boutique en ligne » → « Thèmes » → « Personnaliser »',
  stepTwo: 'Étape 2 - Accédez à "Produits" → "Produit par défaut" → entrez dans la page de description du produit',
  stepThree: 'Étape 3 - Cliquez sur "Acheter des boutons" → Cliquez pour activer "Afficher les boutons de paiement dynamique" → "Enregistrer"',
  dynamicCheckoutButton: 'Comment configurer le bouton de paiement dynamique',
  personalInformationTitle: 'Informations sur mon compte',
  personalInformationSubTitle: 'La vérification des informations de compte est un processus visant à garantir que vos informations sont exactes et à jour. Cela implique de vérifier votre numéro de téléphone pour vous assurer qu’il est correct et à jour.',
  personalInformationTips: `Remarque : 
Afin de garantir l'authenticité de vos informations d'identité, nous devons vérifier votre numéro de téléphone portable. Le nom et le numéro de téléphone portable ne peuvent pas être modifiés après vérification et liaison. Si vous ne pouvez pas recevoir le code de vérification ou si vous devez le modifier, veuillez contacter le service client/agent de paiement USAdrop.`,
  contactName: 'Nom du contact',
  contactPhone: 'Numéro de téléphone',
  contactPhoneAreaCode: 'Indicatif régional téléphonique',
  getVerificationCode: 'OBTENIR LE CODE DE VÉRIFICATION',
  verificationCode: 'Le code de vérification',
  pleaseEnter: 'Veuillez saisir {input}',
  pleaseSelect2: 'Veuillez sélectionner {input}',
  fulfillmentPlatform: 'Plateforme de traitement des commandes',
  pleaseEnterCorrect: 'Veuillez saisir correctement {input}',
  sendSuccessfully: 'Envoyer avec succès',
  submitSuccessfully: 'Soumettre avec succès',
  serviceUnavailable: 'Le service n\'est pas disponible',
  loginExpired: 'Connexion expirée, veuillez vous reconnecter',
  toVerification: 'Vers la vérification',
  activeCustomerPaymentTips: 'La vérification des informations personnelles n\'est pas encore terminée, le service de paiement ne peut donc pas être utilisé.',
  activeCustomerPaymentTips2: 'Veuillez cliquer sur « Vérification des informations personnelles » pour terminer la vérification des informations personnelles.',
  skipCartTips1: 'Cette fonctionnalité permet d\'augmenter les taux de conversion des commandes uniques, mais de réduire les taux d\'ajout au panier. Activez-le si nécessaire.',
  skipCartTips2: `Une fois activé, USAdrop Payment désactivera « Ajouter au panier » de Shopify 
et conservez uniquement les boutons de paiement dynamique. Clients 
en cliquant sur ces boutons, vous serez dirigé directement vers la caisse 
page.`,
  skipCartTips3: '(Si le bouton de paiement n\'est pas visible sur les pages produits après avoir activé cette fonctionnalité, suivez le tutoriel pour activer les boutons de paiement dynamiques :',
  advertisingMaterial: 'Tutoriel sur le matériel publicitaire',
  violationRecord: 'Dossier d\'infraction',
  store: 'Magasin',
  state: 'État',
  deadline: 'Date limite',
  needModified: 'Doit être modifié',
  reviewing: 'Révision',
  completed: 'Complété',
  types: 'Taper',
  picture: 'Image',
  details: 'Détails',
  overdue: 'En retard',
  rejected: 'Rejetée',
  operate: 'Fonctionner',
  complete: 'Complète',
  completeTips: 'Nous sommes sur le point de le soumettre pour examen, veuillez vous assurer que les modifications ont été effectuées comme requis !',
  remark: 'Remarque',
  remarkPlaceholder: 'Veuillez saisir une remarque',
  pleaseInputRemark: 'Merci de remplir la remarque',
  facebookPixel: 'Comment configurer Facebook Pixel ?',
  googlePixel: 'Comment configurer Google Pixel ?',
  themeColor: 'Couleur du thème',
  themeColorTips: 'Vous pouvez utiliser ce paramètre pour modifier la couleur du thème de l\'interface "checkout".',
  buttonColor: 'Acheter maintenant',
  buttonColorTips: 'Vous pouvez utiliser ce paramètre pour changer la couleur du bouton « Acheter maintenant ».',
  terminationAgreement: 'Résiliation du contrat',
  installment: 'Tranche',
  unhandledStores: 'Vous avez des magasins illégaux',
  pixelTop1: 'GTM est déjà lié. Vous ne pouvez pas ajouter un autre pixel.',
  pixelTop2: 'Désactivez le pixel actuel avant d\'utiliser GTM.',
  pixelTop3: 'GTM et les autres pixels ne peuvent pas fonctionner en même temps. Besoin d\'aide ? Contactez votre agent.',
  successVideoTop: 'De vraies histoires de réussite',
  paypalTop: 'Veuillez contacter notre agent pour activer le paiement Paypal.',
  errorMessage: 'Une erreur de serveur s\'est produite',
  wiioRechargeTitle: 'Rappel',
  wiioRechargeDesc: 'Veuillez payer les frais mensuels pour utiliser la plateforme.',
  wiilRechargeConfirm: 'Aller sur USAdrop',
  orderPageDesigner: 'Concepteur de page de commande',
  export: 'Exporter',
  exporting: 'Exportation...',
  unknownError: 'Erreur inconnue',
  downloadSuccess: 'Téléchargement réussi',
  defaultExportNotice: 'Par défaut, les journaux des 30 derniers jours seront exportés ; vous pouvez sélectionner une plage maximale de 30 jours',
  pageStyleConfig: 'Configuration du style de page',
  reset: 'Réinitialiser',
  limitedTimeOffer: 'Offre à durée limitée ! Commandez maintenant pour profiter de la réduction !',
  countdownToEnd: 'Temps jusqu\'à la fin de l\'événement :',
  configLoadedSuccess: 'Données de configuration chargées avec succès',
  configLoadedUseDefault: 'Échec du chargement des données de configuration, en utilisant les valeurs par défaut',
  configLoadFailed: 'Échec de la récupération de la configuration, veuillez vérifier le réseau ou le service',
  confirmRestore: 'Êtes-vous sûr de vouloir restaurer la configuration ? Cette action est irréversible',
  warning: 'Avertissement',
  confirmReset: 'Confirmer la réinitialisation',
  submitSuccess: 'Soumis avec succès',
  checkoutConfigSaved: 'Configuration de la page de paiement enregistrée et appliquée avec succès !',
  saveConfigFailed: 'Échec de l\'enregistrement de la configuration, veuillez réessayer plus tard.',
  visualSizeConfig: 'Configuration visuelle et taille',
  width: 'Largeur',
  height: 'Hauteur',
  textAndCountdownConfig: 'Configuration du texte et du compte à rebours (copie marketing)',
  textContent: 'Contenu du texte',
  enterMarketingCopy: 'Veuillez saisir une copie marketing',
  fontSize: 'Taille de la police',
  fontColor: 'Couleur de police',
  fontWeight: 'Poids de la police',
  selectWeight: 'Sélectionnez le poids',
  countdownSettings: 'Paramètres du compte à rebours',
  enableCountdown: 'Activer le compte à rebours',
  countdownPrefix: 'Préfixe du compte à rebours',
  examplePrefix: 'Exemple : Jusqu\'à la fin',
  endTime: 'Heure de fin',
  selectEndTime: 'Sélectionnez l\'heure de fin du compte à rebours',
  textSpacing: 'Espacement texte/minuterie',
  realtimePreview: 'Aperçu en temps réel',
  eventEnded: 'L\'événement est terminé',
  rowInfo: 'Informations sur la ligne {index}',
  icon: 'Icône',
  title: 'Titre',
  bottomTextConfig: 'Configuration du texte inférieur',
  text: 'Texte',
  suggestedSize: 'Taille suggérée',
  logo: 'Logo',
  banner: 'Bannière',
  safetyInfo: 'Informations de sécurité',
  securityIcons: 'Icônes de sécurité',
  description: 'Description',
  confirmSavePageStyle: 'Êtes-vous sûr de vouloir enregistrer la configuration actuelle du style de page ? Une fois enregistré, il prendra effet immédiatement sur la page de paiement.',
  getCodeTip: 'Veuillez d\'abord compléter le domaine de la boutique, la clé API et la clé secrète.',
  getCode: 'Obtenir le code',
  token_helper_tip: 'Obtenez automatiquement le jeton d\'accès via les informations d\'identification du tableau de bord de développement.',
  copySuccess: 'Copié!',
  pleaseFillInClientIdAndSecret: 'Veuillez remplir l\'ID client (clé API) et le secret (clé secrète API)',
  pleaseEnterClientIdAndSecret: 'Veuillez saisir l\'ID client (clé API) et le secret (clé secrète API)',
  pleaseFillInClientIdAndSecretFirst: 'Veuillez d\'abord remplir l\'ID client (clé API) et le secret (clé secrète API).',
  pleaseContactAgent: 'Veuillez contacter l\'agent',
  createStoreMexicoUSAdropPaymentsTitle: 'Créez votre boutique Shopify à partir de 0',
  couponDisplayConfig: 'Affichage des coupons',
  displayMode: 'Mode d\'affichage',
  couponDisplayExpand: 'Développer',
  couponDisplayHide: 'Cacher',
  couponHideModeTipStart:
    'Lorsqu’il est activé, le champ de saisie du coupon est masqué par défaut. Si vous avez configuré un',
  couponHideModeTipEnd:
    'et qu’il est actif, il sera appliqué automatiquement lorsqu’un client passe une deuxième commande. Si vous ne souhaitez pas que les clients utilisent des codes promo, veuillez définir le statut du coupon sur "Désactivé".',
  couponDisplayCollapse: 'Effondrement',
  couponUnselected: 'Désélectionné',
  couponNoAvailable: 'Aucun coupon disponible',
  couponNoCode: 'Aucune saisie obligatoire',
  productPrice: 'Produit',
  productDiscount: 'Rabais',
  productShipping: 'Expédition',
  free: 'Gratuite',
  apply: 'Appliquer',
  orderPreviewPriceProduct: '9999,00 $',
  orderPreviewPriceDiscount: '-0,00 $',
  orderPreviewPriceTotal: '9999,00 $',
  uponTransactionRisks: 'Dès la présentation d\'une demande de remboursement par le consommateur, la partie A se réserve le droit de procéder à un remboursement pour la transaction afin d\'atténuer les risques de transaction plus graves.',
}
